import React from "react";
import './InvestorGrievance.css'

import useMeta from "../../../hooks/useMeta";

import { Link } from "react-router-dom";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

const InverstoreGrievance = () => {

    useMeta({
        title: 'Investor Grievance | Marvel Blinds',
        description: "Name of the Contact person Mr. Mayursinh Oghubha Gohil as Company Secretary & Compliance Officer Marvel Decor Limited Plot No. 211, GIDC Phase II, Dared, Jamnagar, Gujarat – 361004 Tel: +91 288 2730601/02 Email – corporate@marvellifestyle.com   Name of the Contact person Bigshare Services Private Limited SEBI Registration No.: INR000001385 Bharat Tin Works Building., 1st […]",
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/investor-grievance`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Investor Grievance',
            description:
                "Name of the Contact person Mr. Mayursinh Oghubha Gohil as Company Secretary & Compliance Officer Marvel Decor Limited Plot No. 211, GIDC Phase II, Dared, Jamnagar, Gujarat – 361004 Tel: +91 288 2730601/02 Email – corporate@marvellifestyle.com   Name of the Contact person Bigshare Services Private Limited SEBI Registration No.: INR000001385 Bharat Tin Works Building., 1st […]",
            url: `${process.env.REACT_APP_WEBSITE_URL}/investor-grievance`,
            site_name: 'Marvel Blinds',
        },
    });


    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="IG_pg_container">
                <h2 className="IG_pg_title" >
                    INVESTOR GRIEVANCE
                </h2>

                <div className="IG_pg_content">
                    <p>
                        <b>Name of the Contact person</b> Mr. Mayursinh Oghubha Gohil as Company Secretary & Compliance Officer Marvel Decor Limited Plot No. 211, GIDC Phase II, Dared, Jamnagar, Gujarat – 361004 Tel: +91 288 2730601/02 Email – <Link to="mailto:corporate@marvellifestyle.com"> corporate@marvellifestyle.com</Link>
                    </p>
                    <p>
                        <b>Name of the Contact person</b> Bigshare Services Private Limited SEBI Registration No.: INR000001385 Bharat Tin Works Building., 1st Floor, Opp. Vasant Oasis, Makvana Road, Marol, Andheri (East), Mumbai - 400 059 Tel: +91 022 62638200 Email – <Link to="/investor-grievance" >bssahd@bigshareonline.com</Link> Website - <Link to="/investor-grievance" >www.bigshareonline.com</Link>
                    </p>
                    <p>
                        <Link to="/investor-grievance" ><b>Details of Investors' Grievance and Resolvement</b></Link>
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default InverstoreGrievance;